import React from 'react';
import './styles/Team.css';

const Team = () => {
  const teamMembers = [
    {
      name: 'Dr. Mohammad Nayeem Teli',
      role: 'Team Mentor',
      image: './teamHeadshots/teli.png',
      description: 'Senior Lecturer, Department of Computer Science , University of Maryland, College Park',
    },
    {
      name: 'Zaida Diaz',
      role: 'Team Librarian',
      image: './teamHeadshots/zaida.png',
      description: 'Business & Economics Librarian (Librarian III)',
    },
    {
      name: 'Prabhat Jain',
      role: 'Library and Web Liason, Hardware Team',
      image: './teamHeadshots/prabhat.png',
      description: '3rd Year Computer Science major',
    },
    
    {
      name: 'Dania Akil',
      role: 'Mentor, Library and Social Media Liason, Survey',
      image: './teamHeadshots/dania.png',
      description: '3rd Year Business Major',
    },
    {
      name: 'Jaime Coreas-Parada',
      role: 'Team Liaison and Clerk, Software Team',
      image: './teamHeadshots/jaime.png',
      description: '3rd Year Computer Science major',
    },
    
    {
      name: 'Brandon Fox',
      role: 'Financial Liason, Ombudsman, Hardware Team',
      image: './teamHeadshots/brandon.png',
      description: '3rd Year Computer Science major',
    },
   
    {
      name: 'Juno Song',
      role: 'Web Liason, Software Team',
      image: './teamHeadshots/juno.png',
      description: '3rd Year Computer Science major',
    },
    
    // Add more team members
  ];

  return (
    <section className="team">
      <h1>Our Team</h1>
      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="team-member">
            <img src={member.image} alt={member.name} />
            <h3>{member.name}</h3>
            <p className="role">{member.role}</p>
            <p className="description">{member.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Team; 